import { render, staticRenderFns } from "./epmsa010_kl.vue?vue&type=template&id=04d1f3b7&scoped=true"
import script from "./epmsa010_kl.vue?vue&type=script&lang=js"
export * from "./epmsa010_kl.vue?vue&type=script&lang=js"
import style0 from "./epmsa010_kl.vue?vue&type=style&index=0&id=04d1f3b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d1f3b7",
  null
  
)

export default component.exports